var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRevenue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 118,
    viewBox: "0 0 107 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5540_5677)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.9539 116.193C57.923 116.193 74.1111 99.9106 74.1111 79.8257C74.1111 59.7409 57.923 43.459 37.9539 43.459C17.9848 43.459 1.79663 59.7409 1.79663 79.8257C1.79663 99.9106 17.9848 116.193 37.9539 116.193Z",
    stroke: "#0054A6",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5856 70.9613H39.3987V69.2612C39.3987 67.4526 39.2804 66.269 39.0453 65.7103C38.8103 65.1517 38.3057 64.8731 37.5317 64.8731C36.9088 64.8731 36.4432 65.114 36.1318 65.5959C35.8204 66.0778 35.6647 66.8006 35.6647 67.7643C35.6647 69.3711 35.9836 70.4945 36.6229 71.1375C37.2442 71.7805 39.0768 73.0319 42.1206 74.8916C44.7092 76.4638 46.4744 77.6685 47.4162 78.5057C48.3579 79.343 49.1514 80.5266 49.7997 82.0566C50.4465 83.5865 50.7699 85.493 50.7699 87.7759C50.7699 91.4276 49.8955 94.2948 48.1468 96.3744C46.3981 98.454 43.775 99.74 40.279 100.229V104.084H35.5883V100.103C32.8649 99.8334 30.4859 98.7808 28.4512 96.9451C26.4165 95.111 25.3999 91.911 25.3999 87.3452V85.3409H35.5868V87.8512C35.5868 90.6069 35.6916 92.3191 35.9012 92.9877C36.1108 93.6563 36.6199 93.9891 37.4269 93.9891C38.1156 93.9891 38.6291 93.7572 38.9645 93.2919C39.3014 92.8265 39.469 92.1384 39.469 91.2243C39.469 88.9248 39.3088 87.2804 38.9899 86.2911C38.671 85.3017 37.5781 84.2235 35.7111 83.058C32.6014 81.0973 30.4874 79.6547 29.369 78.7331C28.2506 77.8115 27.2849 76.5135 26.4689 74.8404C25.6529 73.1659 25.2457 71.273 25.2457 69.1588C25.2457 66.0989 26.1066 63.697 27.8299 61.9562C29.5531 60.2154 32.1373 59.1402 35.5838 58.7351V55.4629H40.2745V58.7351C43.4186 59.1402 45.7722 60.2019 47.3353 61.9186C48.8984 63.6352 49.6799 66.007 49.6799 69.0323C49.6799 69.4554 49.6455 70.0969 49.5796 70.9598L49.5856 70.9613Z",
    fill: "#0054A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1815 104.085V35.6115H105.278L71.5839 1.73242L37.888 35.6115H56.9862V41.5868",
    stroke: "#0054A6",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5540_5677"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 107,
    height: 118,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevenue);
export default __webpack_public_path__ + "static/media/revenue.7bc5b37ecfd6bfd3cb17619f4531d975.svg";
export { ForwardRef as ReactComponent };